import * as React from 'react';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import { CommunitySettingsPage } from '@/pages/v2/settings/community-settings';
import { CommunityManagersPage } from '@/pages/v2/settings/community-settings/managers';
import { CommunityManagerPage } from '@/pages/v2/settings/community-settings/managers/manager';
import { Layout as CommunitySettingsLayout } from '@/pages/v2/settings/community-settings/components/layout';
import { CommunityMembersPage } from '@/pages/v2/settings/community-settings/members';
import { CommunityMemberPage } from '@/pages/v2/settings/community-settings/members/member';
import CommunitySettingsImport from '@/pages/v2/settings/community-settings/import';
import CommunityActivityPage from '@/pages/v2/settings/community-settings/activity';
import { CommunityAmenitiesPage } from '@/pages/v2/settings/community-settings/amenities';
import { CommunityReservationsPage } from '@/pages/v2/settings/community-settings/reservations';
import CommunityPreferencesPage from '@/pages/v2/settings/community-settings/preferences';

const communitySettingsLayout = (
  <DashboardLayout>
    <CommunitySettingsLayout metadata={{ title: 'Community Settings' }}>
      <Outlet />
    </CommunitySettingsLayout>
  </DashboardLayout>
);

export const route: RouteObject = {
  path: 'settings/community',
  element: communitySettingsLayout,
  children: [
    {
      index: true,
      element: <CommunitySettingsPage />,
    },
    {
      path: 'import',
      element: <CommunitySettingsImport />,
    },
    {
      path: 'amenities',
      element: <CommunityAmenitiesPage />,
    },
    {
      path: 'reservations',
      element: <CommunityReservationsPage />,
    },
    {
      path: 'preferences',
      element: <CommunityPreferencesPage />,
    }, // same structure as reservations - /settings/community/preferences
    {
      path: 'activity',
      element: <CommunityActivityPage />,
    },
    {
      path: 'managers',
      children: [
        {
          index: true,
          element: <CommunityManagersPage />,
        },
        {
          path: ':userId',
          element: <CommunityManagerPage />,
        },
      ],
    },
    {
      path: 'members',
      element: <CommunityMembersPage />,
    },
    {
      path: 'members/:memberId',
      element: <CommunityMemberPage />,
    },
  ],
};
